// noinspection DuplicatedCode

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// noinspection ES6PreferShortImport
import { PageNotFoundComponent } from '../standalone/page-not-found/page-not-found.component';
import { ConfigCompanyComponent } from './config-company/config-company.component';
import { SapQueryComponent } from './sap-query/sap-query.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('../user/dashboard/dashboard.component').then(
        m => m.DashboardComponent
      ),
  },
  {
    path: 'users',
    loadChildren: () =>
      import('../../shared/users/users.module').then(m => m.UsersModule),
  },
  {
    path: 'companies',
    loadChildren: () =>
      import('../../shared/companies/companies.module').then(
        m => m.CompaniesModule
      ),
  },
  {
    path: 'stock-counts',
    loadChildren: () =>
      import('../user/stock-counts/stock-counts.module').then(
        m => m.StockCountsModule
      ),
  },
  {
    path: 'adhoc-scans',
    loadChildren: () =>
      import('../user/adhoc-scans/adhoc-scans.module').then(
        m => m.AdHocScansModule
      ),
  },
  {
    path: 'adhoc-counts',
    redirectTo: 'adhoc-scans',
    pathMatch: 'full',
  },
  {
    path: 'mobile-devices',
    loadChildren: () =>
      import('../user/mobile-devices/mobile-devices.module').then(
        m => m.MobileDevicesModule
      ),
  },
  {
    path: 'qr-generator',
    redirectTo: 'mobile-devices/add',
    pathMatch: 'full',
  },
  {
    path: 'devices',
    redirectTo: 'mobile-devices',
    pathMatch: 'full',
  },
  {
    path: 'sap-query',
    component: SapQueryComponent,
  },
  {
    path: 'config-company',
    component: ConfigCompanyComponent,
  },
  {
    path: 'odata-query-generator',
    loadChildren: () =>
      import('./odata-query-generator/odata-query-generator.module').then(
        m => m.ODataQueryGeneratorModule
      ),
  },
  {
    path: 'maintenance',
    children: [
      {
        path: '',
        redirectTo: 'templates',
        pathMatch: 'full',
      },
      {
        path: 'templates',
        loadChildren: () =>
          import('./maintenance-templates/maintenance-templates.module').then(
            m => m.MaintenanceTemplatesModule
          ),
      },
      {
        path: 'tasks',
        loadChildren: () =>
          import('./maintenance-tasks/maintenance-tasks.module').then(
            m => m.MaintenanceTasksModule
          ),
      },
      {
        path: 'approvals',
        loadComponent: () =>
          import(
            './maintenance-approvals/maintenance-approvals.component'
          ).then(m => m.MaintenanceApprovalsComponent),
      },
    ],
  },
  {
    path: 'login-history',
    loadComponent: () =>
      import('../user/login-history/login-history.component').then(
        m => m.LoginHistoryComponent
      ),
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StaffRoutingModule {}
